"use client";

import React, { useEffect, useRef, useState } from "react";
import SectionHeader from "./section-header";
import Image from "next/image";
import { maternalJourneyData } from "@/lib/data";

const MaternalJourney = () => {
  const [isVisible, setIsVisible] = useState(false);
  const sectionRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const el = sectionRef.current;
    if (!el) return;
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setIsVisible(true);
        }
      },
      { threshold: 0.5 },
    );
    observer.observe(el);
    return () => observer.disconnect();
  }, []);

  return (
    <section
      id="about"
      className="px-4 space-y-5.5 sm:space-y-6 xl:space-y-8 text-surface-dark 2xl:container 2xl:mx-auto 2xl:px-4"
    >
      <div
        ref={sectionRef}
        className="max-w-100 lg:max-w-140 xl:max-w-206 grid place-self-center pt-8 sm:pt-4 lg:pt-8 xl:pt-12 space-y-5 lg:space-y-8 xl:space-y-12"
      >
        <SectionHeader title="MATERNAL JOURNEY" />
        <div className="overflow-hidden">
          <h2
            className={`font-semibold leading-7.5 sm:leading-9 lg:leading-11 xl:leading-14 text-[21px] sm:text-[28px] lg:text-[37px] xl:text-5xl text-center transition-transform duration-[1500ms] delay-[300ms] ease-[cubic-bezier(0.175,0.885,0.32,1.275)] ${
              isVisible ? "translate-y-0" : "translate-y-[120%]"
            }`}
          >
            Support Designed for Every Stage of Motherhood
          </h2>
        </div>
      </div>

      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-5.5 sm:gap-4.5 lg:gap-5">
        {maternalJourneyData.map((stage) => (
          <div
            key={stage.title}
            className="bg-[#f8fafc] outline outline-surface-light shadow-[0px_0px_40px_0px_#E2E2E2B2] rounded-[20px] py-8 sm:py-12 lg:py-14 xl:py-17.5 space-y-2 lg:space-y-4 text-center px-2"
          >
            <div className="grid place-content-center">
              <div className="relative size-10 xl:size-12">
                <Image
                  src={`/images/maternal-journey/${stage.icon}.png`}
                  alt={stage.title}
                  fill
                  {...(stage.id === 1 ? { priority: true } : {})}
                  className="object-cover object-center"
                />
              </div>
            </div>

            <p className="text-primary font-medium text-sm xl:text-base">
              {stage.ageRange}
            </p>
            <h3 className="font-semibold text-[17px] lg:text-xl xl:text-2xl ">
              {stage.title}
            </h3>
            <p className="font-normal text-sm leading-6 sm:leading-5.5 min-h-16.5 max-w-[90%]">
              {stage.description}
            </p>

            {/* <button className="mt-2 lg:mt-4.5 xl:mt-6 inline-flex items-center gap-x-2 font-semibold text-sm xl:text-base text-primary cursor-pointer ">
              <span className="text-primary">Explore</span>{" "}
              <span>
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="#0052CC"
                  stroke-width="1.75"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  className="size-5 xl:size-6"
                >
                  <path d="M5 12h14" />
                  <path d="m12 5 7 7-7 7" />
                </svg>
              </span>
            </button> */}
          </div>
        ))}
      </div>
    </section>
  );
};

export default MaternalJourney;
